import { ILogger } from './interface';
import { datadogLogs } from '@datadog/browser-logs';

export class ProductionLogger implements ILogger {
  error(message: string, error: Error, stackTrace: string): void {
    datadogLogs.logger.error(message, { error, stackTrace });
  }
  warn(message: string, error?: Error, stackTrace?: string): void {
    datadogLogs.logger.warn(message, { error, stackTrace });
  }
  info(message: string): void {
    datadogLogs.logger.info(message);
  }
  debug(message: string): void {
    datadogLogs.logger.debug(message);
  }
}
